export const CURRENT = 'current';
export const ANTITHEFT = 'antiTheft';
